import React from 'react';

import type { SVGProps } from 'react';

const CaretFirstIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 10.5L6.64865 6L11 1.4L9.67568 0L4 6L9.67568 12L11 10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10.5L2.64865 6L7 1.4L5.67568 0L0 6L5.67568 12L7 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretFirstIcon;
